<!-- table data loading spinner -->
<div class="loader dataload commentsLoader">
    page loading! plase wait
</div>